import palette from "src/theme/palette";

export const SANKEY_COLORS = {
  PRIMARY: "#7C5CFC", // not yet part of palette
  PURPLE_LIGHT: "#A78BFA", // not yet part of palette
  BLUE_DARK: "#2450BA", // figma "Account & Profile/200", not yet part of palette
  TEAL: "#14B8A6", // not yet part of palette
  BLUE: "#3B82F6", // not yet part of palette
  LILAC: "#C084FC", // not yet part of palette
  GREY: palette.grey[400],
  LEAF: palette.grey[500]
};

export const SANKEY_NODE_OPACITY = { DIM: 0.15, DEFAULT: 0.85, HOVER: 1 };
export const SANKEY_LINK_OPACITY = { DIM: 0.1, DEFAULT: 0.3, HOVER: 0.4 };
export const SANKEY_CARD_DIM_OPACITY = 0.1;
export const SANKEY_HOVER_TRANSITION = "opacity 0.2s ease";

// enforced constant gap between stacked node rects (8px gap + 38px card + 8px gap, per Figma)
export const SANKEY_NODE_SPACING = 54;
export const SANKEY_NODE_THICKNESS = 28;
export const SANKEY_NODE_BORDER_RADIUS = 4;
export const SANKEY_MIN_NODE_HEIGHT_RATIO = 0.04;
export const SANKEY_MIN_BEND_THICKNESS = 6;
export const SANKEY_LEGEND_ICON_SIZE = 14;

export const SANKEY_TOOLTIP_HIDE_DELAY = 250;

export const SANKEY_CARD_GAP = 8;
// cards may reach a little past the next column's nodes — the strip beside a node is
// empty ribbon space, and this covers the few px the longest labels are short by
export const SANKEY_CARD_OVERHANG = 32;
export const SANKEY_CARD_HEIGHT = 38;
// a card too narrow for its label and value side by side wraps to two rows; the top
// margin fits that taller card so the first row is never cut off by the chart edge
export const SANKEY_CARD_WRAPPED_HEIGHT = 52;
export const SANKEY_TOP_MARGIN = SANKEY_CARD_WRAPPED_HEIGHT + SANKEY_CARD_GAP;
// per Figma: ~250px free right of the last column so its cards render without truncation
export const SANKEY_RIGHT_MARGIN = 196;
// below this width the chart stops shrinking and scrolls horizontally instead
export const SANKEY_MIN_CHART_WIDTH = 640;

// per Figma Elevation/2 — theme.shadows[2] is too light for the floating node cards
export const SANKEY_CARD_SHADOW = "0px 3px 1px -2px rgba(59, 83, 105, 0.2), 0px 2px 2px 0px rgba(59, 83, 105, 0.14), 0px 1px 5px 0px rgba(59, 83, 105, 0.12)";

// per Figma: chart zone of the sankey card (784px component minus paddings, legend row and divider)
export const SANKEY_DEFAULT_HEIGHT = 550;
